/**
 * Villa Glory — Trade Program craft video (muted autoplay helper)
 */
(function () {
  'use strict';

  var video = document.querySelector('[data-vg-trade-craft-video-el]');
  if (!video) return;

  var wrap = video.closest('[data-vg-trade-craft-video]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    video.removeAttribute('autoplay');
    if (wrap) wrap.classList.add('is-reduced-motion');
    return;
  }

  video.muted = true;

  var playPromise = video.play();
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function () {
      if (wrap) wrap.classList.add('is-paused');
    });
  }
})();
